/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */

// components imports
import { Grid, Tooltip } from "antd";
import { CloseOutlined, SyncOutlined, CheckOutlined, ExclamationOutlined } from "@ant-design/icons";

// misc imports
import { PaymentIntentStatus } from "@/interfaces/PaymentIntent.interface";

const {useBreakpoint} = Grid;

const statusIcon = {
  canceled: <CloseOutlined />,
  processing: <SyncOutlined spin />,
  succeeded: <CheckOutlined />,
  requires_action: <ExclamationOutlined />,
  requires_capture: <ExclamationOutlined />,
  requires_confirmation: <ExclamationOutlined />,
  requires_payment_method: <ExclamationOutlined />,
};

const baseClassName = "status";

export const PaymentStatus = ({ status, responsive = false }: { status: PaymentIntentStatus; responsive: boolean }) => {
  const screens = useBreakpoint();
  const isScreenBelow = (size: "sm" | "md" | "lg" | "xl" | "xxl") => screens.xs || (screens.sm && !screens[size]);
  const content = (
    <span className={`${baseClassName} ${baseClassName}__${status}`}>
      {responsive && !isScreenBelow("md") && status} {statusIcon[status]}
    </span>
  );

  // Wrap with Tooltip only when responsive is true and screen is below "md"
  return responsive && isScreenBelow("md") ? (
    <Tooltip title={<span style={{textTransform: 'capitalize'}}>{status}</span>} placement="top">
      {content}
    </Tooltip>
  ) : (
    content
  );

};